import { useState } from 'react';
import { Handshake } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { ManualReferralModal } from '../../manual-referrals/ManualReferralModal';

/**
 * Feature 117: Referrals tab header action. Opens the manual referral modal in
 * create mode with the referred party picked from search (no launching
 * profile). The caller gates it on MANAGE_USERS_AND_RESOURCES.
 */
export const RegisterReferralButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setIsOpen(true)} className="bg-[#15543e] hover:bg-[#0f3f2e]">
        <Handshake className="mr-2 h-4 w-4" />
        Register referral
      </Button>
      {isOpen && <ManualReferralModal open={isOpen} onOpenChange={setIsOpen} />}
    </>
  );
};
